import { CollapsibleListCell } from '@app/components/various/Table';
import { AccountMarket, Cms } from '@typings';
import cx from 'classnames';

import { PreviouslyTableCell } from '../PreviouslyTableCell/PreviouslyTableCell';

interface Props {
  marketsData: AccountMarket[];
  row: Cms.Page;
}

const renderMarkets = (shouldTruncate: boolean) => (accountMarkets: AccountMarket[]) =>
  accountMarkets.map(market => (
    <span key={market.id} className={cx("after:whitespace-pre [&:not(:last-of-type)]:after:content-[',_']", { truncate: shouldTruncate })}>
      {market.name}
    </span>
  ));

export const MarketsCell = ({ marketsData, row }: Props) => (
  <PreviouslyTableCell property="markets" page={row} render={renderMarkets(false)} previousClassName="w-[calc(100%-16px)]">
    <CollapsibleListCell items={renderMarkets(true)(marketsData)} />
  </PreviouslyTableCell>
);
